import { lazy, ComponentType } from "react";

export const LazyMatchAiLoading: ComponentType<any> = lazy(() =>
  import("../ui/MatchAiLoading").then((module) => ({
    default: module.MatchAiLoading,
  }))
);

export const LazyDatePicker: ComponentType<any> = lazy(() =>
  import("../ui/DatePicker").then((module) => ({ default: module.DatePicker }))
);

export const LazyTabs: ComponentType<any> = lazy(() =>
  import("../ui/Tabs").then((module) => ({ default: module.Tabs }))
);

export const LazySearchableItemList: ComponentType<any> = lazy(() =>
  import("../ui/SearchableItemList").then((module) => ({
    default: module.SearchableItemList,
  }))
);

export const LazySwiper: ComponentType<any> = lazy(() =>
  import("../ui/Swiper").then((module) => ({ default: module.Swiper }))
);

export const IntrodactionForm = lazy(() =>
  import("@features/introduction").then((module) => ({
    default: module.IntrodactionForm,
  }))
);

export const EmptyProfile = lazy(() =>
  import("@pages/emptyProfile").then((module) => ({
    default: module.EmptyProfile,
  }))
);
export const ErrorPage = lazy(() =>
  import("@pages/error").then((module) => ({ default: module.ErrorPage }))
);
export const AuthError = lazy(() =>
  import("@pages/AuthError").then((module) => ({ default: module.AuthError }))
);
export const Itroduction = lazy(() =>
  import("@pages/introduction").then((module) => ({
    default: module.Itroduction,
  }))
);
export const Match = lazy(() =>
  import("@pages/match").then((module) => ({ default: module.Match }))
);
export const Profile = lazy(() =>
  import("@pages/profile").then((module) => ({ default: module.Profile }))
);

export const UserPage = lazy(() =>
  import("@pages/user").then((module) => ({ default: module.UserPage }))
);
